import { gql } from 'apollo-angular';
import { questionContainerFields } from '@ui/legacy-lib';
import { paginationQuery } from '@ui/legacy-lib';
import { propertyPsSide, rentDepositInfoFields } from '@ui/legacy-lib';

export const basicPropertySearcherFields = `
  id
  created
  updated
  status
`;

export const captchaSettingsFields = `
  siteKey
  whitelabelRegistrationProcessActive
  applicationSubmissionActive
  appointmentBookingActive
`;

export const additionalPropertySearcherFields = `
  inInternalPool
  userAllowedToSendMessage
  conversationId
  propertyTenantUserId
  askedForIntent
  acceptedAppointment
  applicantStatus
  upcomingAppointmentDate
  upcomingAppointmentId
  appointmentSlotsAvailable
  applicationBlocked
  downloadExposeAllowed
  downloadExposeUrl
`;

export const propertySearcherFields = `
  ${basicPropertySearcherFields}
  ${additionalPropertySearcherFields}
  ${propertyPsSide}
`;

export const allPropertySearcherFields = `
  ${propertySearcherFields}
  rentDepositInfo {
    ${rentDepositInfoFields}
  }
`;

export const propertyApplyProcessFields = `
  nodes {
    id
    type
    status
    appointmentSlotsAvailable
    upcomingAppointmentDate
    upcomingAppointmentId
    hasQuestions
    hasUnansweredQuestions
    conversationExists
    allowedToSendMessage
    askForViewingAppointmentAttendance
    smsVerificationRequired
    customerId
    captchaSettings {
      ${captchaSettingsFields}
    }
    questionContainer {
      ${questionContainerFields}
    }
    rentDepositInfo {
      ${rentDepositInfoFields}
    }
    ${propertyPsSide}
  }
  page {
    ${paginationQuery}
  }
`;

export const propertyApplyProcessPSBeansQuery = gql`
  query propertyApplyProcessPSBeans($filter: Filter){
    propertyApplyProcessPSBeans(filter: $filter) {
      ${propertyApplyProcessFields}
    }
  }

`;

export const propertyApplyProcessPSBeanQuery = gql`
  query propertyApplyProcessPSBean($id: ID!){
    propertyApplyProcessPSBean(id: $id) {
      id
      type
      status
      appointmentSlotsAvailable
      upcomingAppointmentDate
      upcomingAppointmentId
      hasQuestions
      hasUnansweredQuestions
      conversationExists
      allowedToSendMessage
      askForViewingAppointmentAttendance
      smsVerificationRequired
      customerId
      captchaSettings {
        ${captchaSettingsFields}
      }
      rentDepositInfo {
        ${rentDepositInfoFields}
      }
      ${propertyPsSide}
    }
  }
`;

export const customQuestionsByApplicationQuery = gql`
  query customQuestionsByApplication($id: ID!) {
    customQuestionsByApplication(id: $id) {
      ${questionContainerFields}
    }
  }
`;
